import { Command } from 'commander';
import chalk from 'chalk';
import { join, dirname } from 'path';
import { existsSync } from 'fs';
import { logger } from '../lib/logger.js';

const DOCS_PAGES = ['index', 'installation', 'init', 'commands', 'cli-commands', 'agents', 'gitflow', 'efcore', 'hooks', 'test-web'] as const;
type DocsPage = typeof DOCS_PAGES[number];

export const docsCommand = new Command('docs')
  .alias('d')
  .description('Open SmartStack documentation in browser')
  .argument('[page]', 'Documentation page to open', 'index')
  .option('-l, --list', 'List available documentation pages')
  .action(async (page: string, options) => {
    if (options.list) {
      logger.header('Available Documentation Pages');
      console.log();
      for (const p of DOCS_PAGES) {
        const label = p === 'index' ? `${p} (home)` : p;
        console.log(`  ${chalk.cyan('smartstack docs')} ${chalk.yellow(p)}  ${chalk.gray('→')} ${label}`);
      }
      console.log();
      return;
    }

    const pageName = page.replace('.html', '') as DocsPage;

    if (!DOCS_PAGES.includes(pageName)) {
      logger.error(`Unknown page: ${page}`);
      console.log(`Available pages: ${DOCS_PAGES.join(', ')}`);
      return;
    }

    // __dirname is 'dist' after bundling, so go up one level
    const docsPath = join(dirname(__dirname), '.documentation', `${pageName}.html`);

    if (!existsSync(docsPath)) {
      logger.error('Documentation not found');
      logger.info(`Expected at: ${docsPath}`);
      return;
    }

    logger.info(`Opening ${chalk.cyan(pageName)} documentation...`);

    const { exec } = await import('child_process');
    const fileUrl = `file:///${docsPath.replace(/\\/g, '/')}`;

    const command = process.platform === 'win32'
      ? `start "" "${fileUrl}"`
      : process.platform === 'darwin'
        ? `open "${fileUrl}"`
        : `xdg-open "${fileUrl}"`;

    exec(command, (error) => {
      if (error) {
        logger.error(`Failed to open browser: ${error.message}`);
        logger.info(`Manual path: ${docsPath}`);
      }
    });
  });
